var jade = require("/opt/codecombat/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (features, me, serverConfig, serverSession, view) {
jade_mixins["box"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"well text-center\">");
if ( me.isAnonymous() == true)
{
buf.push("<h6 id=\"classroom-edition-header\" data-i18n=\"new_home.classroom_edition\"></h6><div><button data-event-action=\"Homepage Click Teacher Button CTA\" data-i18n=\"new_home.im_a_teacher\" class=\"teacher-btn btn btn-primary btn-lg btn-block\"></button></div><div><button data-event-action=\"Homepage Click Student Button CTA\" data-i18n=\"new_home.im_a_student\" class=\"student-btn btn btn-forest btn-lg btn-block\"></button></div><h6 id=\"learn-to-code-header\" data-i18n=\"new_home.learn_to_code\"></h6><a" + (jade.attr("href", view.playURL, true, true)) + " data-event-action=\"Homepage Play Now CTA\" data-i18n=\"new_home.play_now\" class=\"btn btn-gold btn-lg btn-block play-btn\"></a>");
}
else
{
buf.push("<h6 id=\"classroom-edition-header\" data-i18n=\"new_home.logged_in_as\"></h6><p class=\"small userName\">" + (jade.escape(null == (jade_interp = me.broadName()) ? "" : jade_interp)) + "</p>");
if ( me.isTeacher())
{
buf.push("<div><a href=\"/teachers/classes\" data-event-action=\"Homepage Click My Classes CTA\" data-i18n=\"new_home.goto_classes\" class=\"my-classes-btn btn btn-forest btn-lg btn-block\"></a></div><div><a href=\"/teachers/resources\" data-event-action=\"Homepage Click Resource Hub CTA\" data-i18n=\"teacher.resource_hub\" class=\"resource-btn btn btn-primary btn-lg btn-block\"></a></div><div>");
if ( !view.isTeacherWithDemo)
{
buf.push("<h6 data-i18n=\"new_home.want_coco\"></h6><button data-event-action=\"Homepage Request Demo CTA\" data-i18n=\"new_home.request_demo\" class=\"btn btn-primary btn-lg request-demo\"></button>");
}
buf.push("</div>");
}
else if ( me.isStudent())
{
buf.push("<div><a" + (jade.attr("href", view.playURL, true, true)) + " data-event-action=\"Homepage Classroom Continue Playing CTA\" data-i18n=\"courses.continue_playing\" class=\"btn btn-forest btn-lg btn-block play-btn\"></a></div><div><a" + (jade.attr("href", view.playURL, true, true)) + " data-event-action=\"Homepage View Progress CTA\" data-i18n=\"new_home.go_to_courses\" class=\"btn btn-primary btn-lg btn-block play-btn\"></a></div>");
}
else
{
buf.push("<div><a" + (jade.attr("href", view.playURL, true, true)) + " data-event-action=\"Homepage Campaign Continue Playing CTA\" data-i18n=\"courses.continue_playing\" class=\"btn btn-forest btn-lg btn-block play-btn\"></a></div><div><a" + (jade.attr("href", ("/user/" + me.getSlugOrID()), true, true)) + " data-event-action=\"Homepage View Profile CTA\" data-i18n=\"new_home.view_profile\" class=\"btn btn-primary btn-lg btn-block profile-btn\"></a></div>");
}
buf.push("<p class=\"small\"><span data-i18n=\"courses.not_you\"></span><span>&nbsp;</span><a data-i18n=\"login.log_out\" href=\"#\" class=\"logout-btn\"></a></p>");
}
buf.push("</div>");
if ( (me.get('preferredLanguage', true) || 'en-US').split('-')[0] == 'nl')
{
buf.push("<div id=\"ideal-tickets-well\" class=\"well text-center hidden-xs hidden-sm\"><h6>Thuis versie:</h6><a href=\"http://codecombat.nl/kopen\" class=\"btn btn-purple btn-lg btn-block\">Prepaid codes (iDeal)</a></div>");
}
};
jade_mixins["accountLinks"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<li><a" + (jade.attr("href", "/user/" + (me.getSlugOrID()) + "", true, true)) + " data-i18n=\"nav.profile\"></a></li><li><a href=\"/account/settings\" data-i18n=\"play.settings\"></a></li>");
if ( me.isAdmin() || !(me.isTeacher() || me.isStudent() || me.freeOnly()))
{
buf.push("<li><a href=\"/account/payments\" data-i18n=\"account.payments\"></a></li>");
}
if ( me.isAdmin() || !(me.isTeacher() || me.isStudent() || me.freeOnly()) || me.hasSubscription())
{
buf.push("<li><a href=\"/account/subscription\" data-i18n=\"account.subscription\"></a></li>");
}
if ( me.isAdmin())
{
buf.push("<li><a href=\"/admin\" data-i18n=\"account_settings.admin\"></a></li>");
}
if ( serverSession && serverSession.amActually)
{
buf.push("<li><a id=\"nav-stop-spying-button\">Stop Spying</a></li>");
}
if ( !features.codePlay)
{
buf.push("<li><a id=\"logout-button\" data-i18n=\"login.log_out\"></a></li>");
}
};
buf.push("<div class=\"style-flat\"><nav id=\"main-nav\" class=\"navbar navbar-default\"><div class=\"container-fluid container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"navbar-header\"><button data-toggle=\"collapse\" data-target=\"#navbar-collapse\" aria-expanded=\"false\" class=\"navbar-toggle collapsed\"><span data-i18n=\"nav.toggle_nav\" class=\"sr-only\"></span><span class=\"icon-bar\"></span><span class=\"icon-bar\"></span><span class=\"icon-bar\"></span></button><a href=\"/home\" class=\"navbar-brand\">");
if ( serverConfig.codeNinjas)
{
buf.push("<img id=\"logo-img\" src=\"/images/pages/base/logo.png\" class=\"code-ninjas-powered-by\"><img src=\"/images/pages/base/code-ninjas-logo-right.png\" class=\"code-ninjas-logo\">");
}
else
{
buf.push("<img id=\"logo-img\" src=\"/images/pages/base/logo.png\">");
}
buf.push("<span class=\"glyphicon glyphicon-home\"></span></a></div>");
if ( !serverConfig.static)
{
buf.push("<div id=\"navbar-collapse\" class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav\">");
if ( view.id !== 'home-view')
{
buf.push("<li><a href=\"/about\" data-i18n=\"nav.about\"></a></li>");
}
if ( me.isStudent())
{
buf.push("<li><a href=\"/students\" data-i18n=\"nav.my_courses\"></a></li>");
}
if ( !me.isAnonymous() && me.isTeacher())
{
buf.push("<li><a href=\"/teachers/classes\" data-i18n=\"nav.my_classrooms\"></a></li>");
}
if ( !me.isAnonymous() && !me.isStudent() && !me.isTeacher())
{
buf.push("<li><a href=\"/play\" data-i18n=\"common.play\"></a></li>");
if ( view.id !== 'home-view')
{
buf.push("<li><a" + (jade.attr("href", view.forumLink(), true, true)) + " data-i18n=\"nav.forum\"></a></li>");
}
}
buf.push("</ul>");
if ( me.isAnonymous())
{
buf.push("<ul class=\"nav navbar-nav\">");
if ( serverConfig.registrationEnabled !== false)
{
buf.push("<li><a id=\"create-account-link\" data-i18n=\"login.sign_up\" class=\"signup-button\"></a></li>");
}
buf.push("<li><a id=\"login-link\" data-i18n=\"login.log_in\" class=\"login-button\"></a></li></ul>");
}
else
{
buf.push("<ul class=\"nav navbar-nav hidden-md hidden-lg\"><li class=\"disabled\"><a><img" + (jade.attr("src", me.getPhotoURL(), true, true)) + (jade.cls(['img-circle','img-circle-small','m-r-1',(me.isTeacher() ? 'border-navy' : '')], [null,null,null,true])) + "><span>" + (jade.escape(null == (jade_interp = me.displayName()) ? "" : jade_interp)) + "</span></a></li>");
jade_mixins["accountLinks"]();
buf.push("</ul><ul class=\"nav navbar-nav\"><li class=\"dropdown hidden-xs hidden-sm\"><a href=\"#\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\" class=\"dropdown-toggle\"><img" + (jade.attr("src", me.getPhotoURL(), true, true)) + (jade.cls(['img-circle','img-circle-small','m-r-1',(me.isTeacher() ? 'border-navy' : '')], [null,null,null,true])) + "><span data-i18n=\"nav.my_account\"></span></a><ul class=\"dropdown-menu\"><li class=\"user-dropdown-header text-center\"><span class=\"user-level\">" + (jade.escape(null == (jade_interp = me.level()) ? "" : jade_interp)) + "</span><a" + (jade.attr("href", "/user/" + (me.getSlugOrID()) + "", true, true)) + "><img" + (jade.attr("src", me.getPhotoURL(), true, true)) + (jade.cls(['img-circle',(me.isTeacher() ? 'border-navy' : '')], [null,true])) + "></a><h5>" + (jade.escape(null == (jade_interp = me.broadName()) ? "" : jade_interp)) + "</h5></li>");
jade_mixins["accountLinks"]();
buf.push("</ul></li></ul>");
}
buf.push("<ul class=\"nav navbar-nav\"><li><div id=\"language-dropdown-wrapper\"><select class=\"language-dropdown form-control\"></select></div></li></ul></div>");
}
buf.push("</div></div></div></nav><div id=\"site-content-area\"><div id=\"jumbotron-container-fluid\" class=\"container-fluid alt-image\"><div class=\"container\"><div style=\"height: 160px\" class=\"row hidden-xs top-spacer\"></div><div class=\"row hidden-sm hidden-xs\"><div class=\"col-lg-7 col-md-8\"><h1 data-i18n=\"new_home.slogan\"></h1></div><div class=\"col-lg-3 col-lg-offset-2 col-md-4\">");
jade_mixins["box"]();
buf.push("</div></div><div class=\"row hidden-lg hidden-md\"><div class=\"col-lg-7 col-md-8\"><h1 data-i18n=\"new_home.slogan\"></h1></div><div class=\"col\"><div style=\"margin: auto; max-width: 300px\">");
jade_mixins["box"]();
buf.push("</div></div></div></div></div></div></div>");}.call(this,"features" in locals_for_with?locals_for_with.features:typeof features!=="undefined"?features:undefined,"me" in locals_for_with?locals_for_with.me:typeof me!=="undefined"?me:undefined,"serverConfig" in locals_for_with?locals_for_with.serverConfig:typeof serverConfig!=="undefined"?serverConfig:undefined,"serverSession" in locals_for_with?locals_for_with.serverSession:typeof serverSession!=="undefined"?serverSession:undefined,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/home-view.jade
// module id = 1441
// module chunks = 82